import { CategoryGrouping } from '../types';
import { EXPERIMENT_IDENTIFIERS } from '~server/routes/Pricing/experimentsConfig';
import teamGroupings from './teams';
import individualGroupings from './individual';
import { PackageType } from '~shared/types/pricing/package';

import GROW_2529_INDIVIDUAL_GROUPINGS from '~pricing/experiments/grow_2529_forms/transformers/details/groupings/individual';
import GROW_2792_GROUPINGS from '~pricing/experiments/grow_2792_pnp_refresh_v1/transformers/details/groupings';
import COPY from '~pricing/lib/PackageFeatures/details/categoryCopy';

export const categoryIds = {
  team_collaboration: COPY.TEAM_COLLABORATION.defaultMessage,
  team_management: COPY.TEAM_MANAGEMENT.defaultMessage,
  enterprise_grade_security: COPY.ENTERPRISE_GRADE_SECURITY.defaultMessage,
  survey_capabilities: COPY.SURVEY_CAPABILITIES.defaultMessage,
  fast_support: COPY.FAST_SUPPORT.defaultMessage,
  survey_builder: COPY.SURVEY_BUILDER.defaultMessage,
  customization_branding: COPY.CUSTOMIZATION_BRANDING.defaultMessage,
  analysis_reporting: COPY.ANALYSIS_REPORTING.defaultMessage,
  response_management: COPY.RESPONSE_MANAGEMENT.defaultMessage,
  enhanced_security: COPY.ENHANCED_SECURITY.defaultMessage,
  partner_integrations: COPY.PARTNER_INTEGRATIONS.defaultMessage,
};

const categoryGroupings: CategoryGrouping = {
  [PackageType.Teams]: {
    default: teamGroupings,
    [EXPERIMENT_IDENTIFIERS.GROW_2792.treatment]: GROW_2792_GROUPINGS,
  },
  [PackageType.Details]: {
    default: teamGroupings,
    [EXPERIMENT_IDENTIFIERS.GROW_2792.treatment]: GROW_2792_GROUPINGS,
  },
  [PackageType.Individual]: {
    default: individualGroupings,
    [EXPERIMENT_IDENTIFIERS.GROW_2529_FORMS.treatment1]: GROW_2529_INDIVIDUAL_GROUPINGS,
    [EXPERIMENT_IDENTIFIERS.GROW_2529_FORMS.treatment2]: GROW_2529_INDIVIDUAL_GROUPINGS,
    [EXPERIMENT_IDENTIFIERS.GROW_2629_FORMS_V2.treatment]: GROW_2529_INDIVIDUAL_GROUPINGS,
    [EXPERIMENT_IDENTIFIERS.GROW_2792.treatment]: GROW_2792_GROUPINGS,
  },
  [PackageType.Educational]: {
    default: individualGroupings,
  },
};

export default categoryGroupings;
